// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3fhXy","wrapper":"Auth_wrapper__2BvRM","title":"Auth_title__2MfHJ","form":"Auth_form__wjp3Q","buttons":"Auth_buttons__5wBBI"};